<template>
  <div class="pagination-bar">
    <div class="pagination-meta">
      <span>第 {{ pageNum }} / {{ maxPage }} 页</span>
      <span v-if="total">显示 {{ start }} - {{ end }}，共 {{ total }} 条</span>
      <span v-else>暂无数据</span>
    </div>
    <div class="pagination-actions">
      <select :value="pageSize" class="page-select" @change="handleSizeChange">
        <option v-for="size in pageSizeOptions" :key="size" :value="size">
          {{ size }} 条/页
        </option>
      </select>
      <button class="page-chip" :disabled="pageNum <= 1" @click="emit('change-page', pageNum - 1)">
        上一页
      </button>
      <button class="page-chip" :disabled="pageNum >= maxPage" @click="emit('change-page', pageNum + 1)">
        下一页
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  pageNum: {
    type: Number,
    default: 1
  },
  pageSize: {
    type: Number,
    default: 10
  },
  total: {
    type: Number,
    default: 0
  },
  totalPages: {
    type: Number,
    default: 0
  },
  pageSizeOptions: {
    type: Array,
    default: () => [10, 20, 50]
  }
});

const emit = defineEmits(['change-page', 'change-size']);

const maxPage = computed(() => {
  if (props.totalPages > 0) {
    return props.totalPages;
  }
  if (!props.total || !props.pageSize) {
    return 1;
  }
  return Math.ceil(props.total / props.pageSize);
});

const start = computed(() => {
  if (!props.total) {
    return 0;
  }
  return (props.pageNum - 1) * props.pageSize + 1;
});

const end = computed(() => {
  if (!props.total) {
    return 0;
  }
  return Math.min(props.pageNum * props.pageSize, props.total);
});

function handleSizeChange(event) {
  emit('change-size', Number(event.target.value));
}
</script>
